import { denormalisedResponseEntities } from '../../util/data';
import { types as sdkTypes } from 'sharetribe-flex-sdk';


// ================ Reducer ================ //

const initialState = {
  fetchInProgress: false,
  pagination: null,
};

// ================ Thunks ================ //

export const loadData = (params, search, config) => (dispatch, getState, sdk) => {
  // Do nothing, just return a resolved promise
  return Promise.resolve();
};


export default {
  loadData,
};
